import { Component, Input, OnInit } from '@angular/core';
import { User, UserGroup } from "../../../app/app.interfaces";
import {AuthService} from "../../../services/auth.service";
import { NavController } from "ionic-angular";
import {ApiService} from "../../../services/api.service";
import {LoginRequired} from "../../../decorators/login.required";
import {Location} from '@angular/common';


@Component({
  selector: 'user-statistics',
  templateUrl: 'user-statistics.html'
})
export class UserStatistics implements OnInit {

	@Input() user?: User;

  constructor(public authService: AuthService) {
  }


  ngOnInit(): void {
    if(!this.user){
      this.user = this.authService.user;
    }
  }
}



// WEBPACK FOOTER //
// ./src/partials/user/user-statistics/user-statistics.ts